import { useRouter } from '@application/utils';

export const useTranslationInput = () => {
  const { language } = useRouter();

  return {
    translationInput: {
      translationsWhere: {
        language: {
          equals: language,
        },
      },
    },
  };
};
